import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  LOCALE_ID,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Criteria } from 'src/app/website/pages/core/entities/filter';
import { FilterQuery } from 'src/app/website/pages/core/entities/filter-query';
import { firmaservice } from 'src/app/website/pages/core/services/firmas.service';
import { SesionService } from 'src/app/website/pages/core/services/session.service';
import { Empleado } from 'src/app/website/pages/empresa/entities/empleado';
import { EmpleadoJwtService } from '../../empresa/services/empleado-jwt.service';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

import { firma } from '../../comun/entities/firma';



@Component({
  selector: 'app-formato-firma-sm',
  standalone: true,
  imports: [CommonModule, DialogModule, FormsModule,ButtonModule],
  templateUrl: './formato-firma-sm.component.html',
  styleUrl: './formato-firma-sm.component.scss'
})
export class FormatoFirmaSMComponent implements OnInit, AfterViewInit {
  @ViewChild('canvasAprobador', { static: false })
  canvasAprobador!: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasMedico', { static: false })
  canvasMedico!: ElementRef<HTMLCanvasElement>;
  ctxAprobador!: CanvasRenderingContext2D;
  ctxMedico!: CanvasRenderingContext2D;
  drawingAprobador = false;
  drawingMedico = false;
  whoSignature: string = '';
  empleadoSelect?: Empleado | null;
  nombreSesion?: string;
  empleadoStorage?: any;
  seguimientoId?: string;
  seguimiento: any;
  visibleDlg:boolean =true
  jwtExpired: boolean = false;

  firm: any = {}; // Objeto compartido para almacenar datos de la firma

  constructor(
    private _firmaservice: firmaservice,
    private _sesionService: SesionService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private empleadoJwtService: EmpleadoJwtService,

    @Inject(LOCALE_ID) private locale: string

    
  ) { }
  ngOnInit(): void {
    const token = this.route.snapshot.params["token"]
    this.buscarEmpleado(token);
    this.buscarTypeUser(token);
    this.buscarSeguimiento(token);



    console.log(token, "ad");

    this.seguimiento = this.route.snapshot.params["id"];
    console.log("Seguimiento:", this.seguimiento);
    const storedSignature = localStorage.getItem('whoSignature');
    this.whoSignature = "aprueba";
    const empleadoStorage: string | null = localStorage.getItem('empleado');
    let seguimientoIdStr: string | null = localStorage.getItem('seguimiento');
    if (seguimientoIdStr !== null) {
      this.seguimientoId = seguimientoIdStr
    } else {
      this.seguimientoId = "";
    }
    if (empleadoStorage) {
      try {
        const empleadoObj: Empleado = JSON.parse(empleadoStorage);
        this.empleadoSelect = empleadoObj;
        console.log('exitoso: ', this.empleadoSelect);
      } catch (error) {
        console.error('Error al parsear el JSON de empleado:', error);
        this.empleadoSelect = null;
      }
    } else {
      this.empleadoSelect = null;
    }

  }
  empleadoData: Empleado| undefined;
  tipoUsuario: any | undefined;
  seguimientoData: any | undefined;

  buscarEmpleado(token: string): void {


    this.empleadoJwtService.findempleadoByUsuario(token)
      .then(res => {
        this.empleadoData = res as Empleado;
        console.log('Empleado encontrado: ', this.empleadoData);

      })
      .catch(err => {
        console.error('Error al buscar el empleado: ', err);
      });
  }
  buscarSeguimiento(token: string): void {
    this.empleadoJwtService.findSeguimientoByID(token)
      .then(res => {
        this.seguimientoData = res;
        console.log('Seguimiento encontrado: ', this.seguimientoData);
      })
      .catch(err => {
        console.error('Error al buscar el seguimiento: ', err);
        if (localStorage.getItem('jwtExpired') === 'true') {
          this.jwtExpired = true;
          localStorage.removeItem('jwtExpired');
        }
      });
  }
  flagNombre:boolean=true
  flagCedula:boolean=true
  nombre?:string;
  cedula?:number;
  input(){

    if(this.nombre)this.flagNombre=(this.nombre.length>7)?false:true
    if(this.cedula)this.flagCedula=((this.cedula.toString()).length>3)?false:true

  }
  
  buscarTypeUser(token: string): void {


    this.empleadoJwtService.findTypeUserByCase(token)
      .then((res:any) => {
        console.log(res);
        
        this.tipoUsuario=res
        this.whoSignature=res.firmador;
        console.log('tipo encontrado: ', this.tipoUsuario);

      })
      .catch(err => {
        console.error('Error al buscar el tipo: ', err);
      });
  }

  ngAfterViewInit() {
    if (this.canvasAprobador != undefined) {
      this.ctxAprobador = this.canvasAprobador.nativeElement.getContext('2d')!;
      this.initializeCanvas(this.ctxAprobador);
    }
    if (this.canvasMedico != undefined) {
      this.ctxMedico = this.canvasMedico.nativeElement.getContext('2d')!;
      this.initializeCanvas(this.ctxMedico);
    }
  }

  initializeCanvas(ctx: CanvasRenderingContext2D) {
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#000000';
  }

  startDrawingAprobador(event: MouseEvent | TouchEvent) {
    this.drawingAprobador = true;
    this.draw(event, this.ctxAprobador);
  }

  startDrawingMedico(event: MouseEvent | TouchEvent) {
    this.drawingMedico = true;
    this.draw(event, this.ctxMedico);
  }

  draw(event: MouseEvent | TouchEvent, ctx: CanvasRenderingContext2D) {
    event.preventDefault();
    let x: number = 0;
    let y: number = 0;
    if (event instanceof MouseEvent) {
      x = event.offsetX;
      y = event.offsetY;
    } else if (event instanceof TouchEvent) {
      const rect = (event.target as HTMLCanvasElement).getBoundingClientRect();
      x = event.touches[0].clientX - rect.left;
      y = event.touches[0].clientY - rect.top;
    }
    if (this.drawingAprobador || this.drawingMedico) {
      ctx.lineTo(x, y);
      ctx.stroke();
    }
  }

  stopDrawingAprobador() {
    this.drawingAprobador = false;
    this.ctxAprobador.beginPath();
  }
  mensaje: string = ''; // Mensaje a mostrar
  mensajeVisible: boolean = false; // Controla la visibilidad del mensaje

  mostrarMensaje(mensaje: string) {
    this.mensaje = mensaje;
    this.mensajeVisible = true;

    // Ocultar el mensaje después de 4 segundos
    setTimeout(() => {
      this.mensajeVisible = false;
    }, 4000);
  }
 
  stopDrawingMedico() {
    this.drawingMedico = false;
    this.ctxMedico.beginPath();
  }

  async savePad() {
    
    console.log(this.tipoUsuario.terminoscondiciones);
    
    if (!this.tipoUsuario || !this.tipoUsuario.firmador) {
      console.error('No se encontró el tipo de usuario o firmador.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo determinar el tipo de usuario para capturar la firma.',
      });
      return;
    }

    if (this.tipoUsuario.firma != null) {
      this.mostrarMensaje('Ya existe una firma registrada. No se requiere guardar una nueva.');
      console.log('Firma ya existente:', this.tipoUsuario.firma);
      return;
    }

    let firmaCapturada: string | null = null;

    if (this.tipoUsuario.firmador === 'aprueba') {
      firmaCapturada = this.canvasAprobador.nativeElement.toDataURL('image/png');
    } else if (this.tipoUsuario.firmador === 'medico') {
      firmaCapturada = this.canvasMedico.nativeElement.toDataURL('image/png');
    }

    if (!firmaCapturada) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error al capturar firma',
        detail: 'No se pudo capturar la firma para el tipo de usuario.',
      });
      return;
    }

    // Agrega los datos de la firma al objeto `firm`
    this.firm = {
      ...this.firm, // Mantén los datos previamente guardados
      firma: firmaCapturada,
      firmador: this.tipoUsuario.firmador,
    };

    console.log('Datos finales a guardar:', this.firm);

    try {
      const resultado = await this._firmaservice.updateFirma(this.firm);
      this.mostrarMensaje('Firma guardada correctamente.');
      console.log('Respuesta del backend:', resultado);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error al guardar la firma',
        detail: 'No se pudo guardar la firma.',
      });
      console.error('Error al guardar la firma:', error);
    }
  }
  terminosyCondiciones(flagTerminos: boolean) {
    this.tipoUsuario.terminoscondiciones = flagTerminos; // Actualiza la variable
    
    this.firm = {
      id: this.tipoUsuario.id,
      idempresa: this.tipoUsuario.idempresa,
      fechacreacion: new Date(),
      idrelacionado: this.tipoUsuario.idrelacionado,
      terminoscondiciones: flagTerminos,
      fechaterminos: new Date(),
      nombre: this.nombre,
      cedula: this.cedula,
    };
  
    console.log('Datos de términos y condiciones guardados:', this.firm);
  
    this.visibleDlg = false; // Cierra el diálogo
  }
  
  




  clearPadDoctor() {
    this.ctxMedico.clearRect(
      0,
      0,
      this.canvasMedico.nativeElement.width,
      this.canvasMedico.nativeElement.height
    );
    this.ctxAprobador.clearRect(
      0,
      0,
      this.canvasAprobador.nativeElement.width,
      this.canvasAprobador.nativeElement.height
    );
    console.log("entra ??");
    
  }

  clearApprove() {
    this.ctxAprobador.clearRect(
      0,
      0,
      this.canvasAprobador.nativeElement.width,
      this.canvasAprobador.nativeElement.height
    );
  }

}
